export default function getFirstDayOfWeek() {
    return 0; // Sunday
}
